import {IconButton} from '@wandb/components';
import React, {useCallback} from 'react';

import {type PanelType} from '../../../util/panelTypes';
import {usePanelContext} from '../PanelContextProvider';
import {PanelPopupMode} from '../types';

export const PanelViewVegaSpec = ({panelType}: {panelType: PanelType}) => {
  const {setPanelPopupMode, isReadOnly} = usePanelContext();

  const onClick = useCallback(() => {
    setPanelPopupMode(PanelPopupMode.VIEW_SPEC);
  }, [setPanelPopupMode]);

  // Only show this action for published reports on vega2 panels
  if (!isReadOnly || panelType !== 'Vega2') {
    return null;
  }

  return (
    <IconButton
      icon="view-alt"
      variant="ghost"
      aria-label="View panel spec"
      size="sm"
      tooltip={{children: 'View panel spec'}}
      onPress={e => {
        e.continuePropagation();
        onClick();
      }}
    />
  );
};
